webpackJsonp([206583366516095],{

/***/ 634:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Share;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactResponsive = __webpack_require__(18);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _assets = __webpack_require__(80);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Share() {
	  return _react2.default.createElement(
	    _spacing2.default,
	    { size: 'xs', sizeM: 'l', type: 'padding', position: 'topBottom' },
	    _react2.default.createElement(
	      _maxWidth2.default,
	      { value: 720 },
	      _react2.default.createElement(
	        _grid2.default,
	        { columns: 2, size: 'l', alignItems: 'center', justifyContent: 'center' },
	        _react2.default.createElement(_reactResponsive2.default, { maxWidth: 1200 }),
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 2, columnSpanM: 1 },
	          _react2.default.createElement(
	            _align2.default,
	            { type: 'center', typeM: 'left' },
	            _react2.default.createElement(
	              _spacing2.default,
	              { size: 's', type: 'padding', position: 'topBottom' },
	              _react2.default.createElement(
	                _heading2.default,
	                { tag: 'h2', weight: 'semibold', size: 'xl' },
	                'Share the download link'
	              )
	            ),
	            _react2.default.createElement(
	              _paragraph2.default,
	              { size: 'l', color: 'slate' },
	              'Marvel will automatically generate a download page for your Android app build. Simply send the link to your device and install.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _grid.GridItem,
	          null,
	          _react2.default.createElement(
	            _spacing2.default,
	            { size: 'l', type: 'padding', position: 'topBottom' },
	            _react2.default.createElement(_Image2.default, _assets2.default.devicesRetina)
	          )
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-android-app-builder-share-js-e2399d82e360ff06d27b.js